import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router'

import { useAppContext } from '../../containers/App/Context'
import { ASSETS_URL } from '../../constants/urls'

import { Content, PanelBody } from './styles'

const ContentPanel = ({
  contentList,
  title,
  subtitle,
  index,
  align,
  currentPhone,
  query,
  createUserEvent
}) => {
  const { versionKey: version } = useAppContext()
  const imageSrc = currentPhone && ASSETS_URL + currentPhone.image_location
  const leftAlign = align === 'left'

  return (
    <Content>
      <Col xsHidden sm={4} smPush={leftAlign ? 8 : 0}>
        <img src={imageSrc} alt={currentPhone.name_pretty} />
      </Col>
      <Col
        sm={leftAlign ? 8 : 6}
        smPull={!leftAlign ? 0 : 4}
        smPush={leftAlign ? 0 : 2}
      >
        <Row>
          <Col xs={1} className="getting-started-index-col">
            <span>{index}</span>
          </Col>
          <PanelBody xs={11} version={version}>
            <h2>{title}</h2>
            <h5>{subtitle}</h5>
            {contentList &&
              contentList.map((content, key) => (
                <Link
                  key={`start_content_${index}${key}`}
                  to={{
                    pathname:
                      '/' + content.contentType + 's/' + content.contentKey,
                    query: query
                  }}
                  onClick={() =>
                    createUserEvent({
                      category: 'navigation',
                      data: {
                        link_to:
                          '/' + content.contentType + 's/' + content.contentKey,
                        source: 'GetStartedLink'
                      }
                    })
                  }
                >
                  <p>{content.contentTitle}</p>
                </Link>
              ))}
          </PanelBody>
        </Row>
      </Col>
    </Content>
  )
}

export default ContentPanel



// WEBPACK FOOTER //
// ./src/components/GettingStarted/ContentPanel.js